var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/array-slice.js
// module id = 102
// module chunks = 0 1